import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
// import PrimaryResourcesCategoryView from "../components/PrimaryResourcesCategoryView"
import SecondaryResourcesCategoryView from "../components/SecondaryResourcesCategoryView"
import ZipLogo from "../images/zip.svg"
import Grade4TB from "../images/primary-4.jpg"

class Primary4Resources extends React.Component {
  state = {
    view: {
      title: "Primary 4 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Grade4TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G4-Primary-4-TB_WM_2022.pdf",
        } /*
        {
          name: "Flashcards",
          fileType: PDFLogo,
          filePath:
            "https://garnet-audio-downloads.s3.eu-west-2.amazonaws.com/Libya-assets/resources-primary-4-oct-19/",
          files: [
            {
              name: "Grade 4 Flashcards",
              file: "LBY0034_G4_Flashcards_FINAL.pdf",
            },
          ],
        },
        {
          name: "Posters",
          fileType: PDFLogo,
          filePath:
            "https://garnet-audio-downloads.s3.eu-west-2.amazonaws.com/Libya-assets/resources-primary-4-oct-19/",
          files: [
            {
              name: "Grade 4 Alphabet Poster",
              file: "LBY0034_G4_Alphabet Poster_FINAL.pdf",
            },
            {
              name: "Grade 4 Body Poster",
              file: "LBY0034_G4_Body Poster_FINAL.pdf",
            },
            {
              name: "Grade 4 Numbers Poster",
              file: "LBY0034_G4_Numbers Poster_FINAL.pdf",
            },
            {
              name: "Grade 4 House Poster",
              file: "LBY0034_G4_House Poster_FINAL.pdf",
            },
          ],
        },*/,
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [{ name: "Grade 4 Audio", file: "Primary-4-audio.zip" }],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <SecondaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Primary4Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesPrimary4.js